import { useMemo } from "react"
import { appConstants } from "../../appConstants"
import { BSBimModel } from "../../dto/beem-shot/BSBimModel/BSBimModel"
import { BSBuilding } from "../../dto/beem-shot/BSBuilding/BSBuilding"
import { BSBuildingCreation } from "../../dto/beem-shot/BSBuilding/BSBuildingCreation"
import { BSBuildingUpdateDto } from "../../dto/beem-shot/BSBuilding/BSBuildingUpdateDto"
import { BSCodeExtraitCreation } from "../../dto/code-extrait/BSCodeExtraitCreation"
import { resolveUrl } from "../../services/http-service"
import { useHttp } from "../use-http"

type BSBuildingHook = {
  getAllBuilding(bsVariantId: string): Promise<BSBuilding[]>
  createBuilding(bsBuildingCreation: BSBuildingCreation): Promise<BSBuilding>
  affectBimModelToBuilding(
    bsBuildingId: string,
    bsBimModelId: string,
    codesExtraits: BSCodeExtraitCreation[]
  ): Promise<BSBimModel>
  putBuildingInfos(bsBuildingUpdateDto: BSBuildingUpdateDto): Promise<BSBuilding>
  getStartEstimating(bsBuildingId: string): Promise<Response>
  sendDeleteBuilding(bsBuildingId: string): Promise<void>
}

export function useBSBuilding(): BSBuildingHook {
  const { get, post, put, deleteRequest } = useHttp()

  return useMemo(
    () => ({
      getAllBuilding(bsVariantId: string): Promise<BSBuilding[]> {
        return get(resolveUrl(appConstants.apiEndpoints.BEEM_SHOT_VARIANT_BUILDING_LIST, [], { bsVariantId })).then(
          (response) => response.json()
        )
      },
      createBuilding(bsBuildingCreation: BSBuildingCreation): Promise<BSBuilding> {
        return post(appConstants.apiEndpoints.BEEM_SHOT_BUILDING, bsBuildingCreation).then((response) => response.json())
      },
      affectBimModelToBuilding(
        bsBuildingId: string,
        bsBimModelId: string,
        codesExtraits: BSCodeExtraitCreation[]
      ): Promise<BSBimModel> {
        return post(appConstants.apiEndpoints.BEEM_SHOT_VARIANT_LINK_BIM_MODEL_TO_BUILDING, codesExtraits, [
          { key: "bsBuildingId", value: bsBuildingId },
          { key: "bsBimModelId", value: bsBimModelId },
        ]).then((response) => response.json())
      },
      putBuildingInfos(bsBuildingUpdateDto: BSBuildingUpdateDto): Promise<BSBuilding> {
        return put(appConstants.apiEndpoints.BEEM_SHOT_BUILDING_UPDATE_INFOS, bsBuildingUpdateDto).then((response) =>
          response.json()
        )
      },
      getStartEstimating(bsBuildingId: string): Promise<Response> {
        return get(resolveUrl(appConstants.apiEndpoints.BEEM_SHOT_BUILDING_START_ESTIMATE, [bsBuildingId]))
      },
      async sendDeleteBuilding(bsBuildingId: string): Promise<void> {
        await deleteRequest(appConstants.apiEndpoints.BEEM_SHOT_BUILDING, [{ key: "bsBuildingId", value: bsBuildingId }])
      },
    }),
    [get, post, put, deleteRequest]
  )
}
